import React from 'react'
import { Radar } from 'react-chartjs'
import ViewBar from '../ViewStatics/ViewBar'
export default class GraphComponent extends React.Component {
  constructor (props) {
    super (props)
    this.state = ({ checklist: [''] })
    }
    componentWillMount () {
      let count = this.props.theads.count
      let state = this.state
      let checklist = state.checklist
      for(let i =0; i<count;i++){
        checklist[i] = 'checklist'
      }
      state.checklist = checklist
      this.setState(state)
    }
    clickHandler (e) {
      let id = parseInt(e.target.id)
      let state = this.state
      let checklist = state.checklist
      if(checklist[id] === 'checklist') {
        checklist[id] = 'none'
      } else {
        checklist[id] = 'checklist'
      }

      state.checklist = checklist
      console.log(checklist,id)
      this.setState(state)
    }
render() {
  let checklist = []
  let con = ['','','','']

  let count = this.props.theads.count
  con = []
  let arrCheck = this.state.checklist
  for(let i =0; i<count; i++){
    con.push('')
  }
  var chartOptions = {
    pointLabelFontSize: 12, scaleShowLabels: true,
    scaleStartValue: 0, scaleOverride: true,
    pointLabelFontColor: '#EFEFEF', scaleSteps: 5, scaleStepWidth: 2,
    backgroundColor:'red',
    scaleBackgroundColors:['rgba(250,250,250,0.9)','rgba(250,250,250,0.9)','rgba(250,250,250,0.9)','rgba(250,250,250,0.9)','rgba(250,250,250,0.9)'],
    scaleFontColor: '#EFEFEF', scaleLineColor: 'rgb(150,150,150)',
    angleLineColor: 'rgba(255,255,255,0.5)', responsive: true,
    scaleBackdropColor: 'rgba(153,153,153,1)',
    scaleLineColor: 'rgb(150,150,150)',
    angleLineColor: 'rgb(150,150,150)',
    lineWidth: 1,
    shadowColor: 'red',
    pointDot: true
  }
const radar = (arrLabel, n) => {
  let colors =['rgba(250, 0, 0, 0.7)','rgba(0, 255, 0, 0.7)','rgba(255, 255, 0, 0.7)','rgba(255, 0, 255, 0.7)', 'rgba(0,130,255,0.7)','rgba(0,130,255,0.7)','rgba(0,130,255,0.7)']
  let arr_ = []
  for(let i=0; i<arrLabel.length; i++){
    n = i
    if(arrCheck[i]!='none')
      {
      arr_.push({label: 'C '+i, fillColor: colors[n],strokeColor:colors[n],highlightFill:colors[n],highlightStroke:colors[n], data: arrLabel[i]})
      }

  }
  return arr_
}
let radar1 = this.props.theads.data1
  let data1 = {
    labels: ['Arterial', 'Metabólica', 'Cardiopulmonar', 'Bienestar', 'Vigor'],
    datasets: radar(radar1,0)
  }
  
  let renderRadar = true
  let none = 0
  arrCheck.forEach((elm)=>{
    if(elm=='none'){
      none = none + 1
    }
  })
  renderRadar = none >= radar1.length? false: true

   return (

     <div className='graph-contianer'>
      <div className='controller-control'>
      {con.map((e,i)=>{ return <div id={`${i}patt`} className='text-cnt' key={i} onClick={this.clickHandler.bind(this)}>
        <div id={`${i}child`} className='checklist'>
          <div id={`${i}check`} className={arrCheck[i]}>✓</div>
        </div> Toma {i}
        <div className={`color${i}`} key={i}></div></div>})}
      </div>
      {renderRadar ?
        <div>
        <div className='container-group'>
          <div className='container-balance-graph'>
            <div><p>Índice de capacidad funcional</p><Radar data={data1} className='chart chart-radar' options={chartOptions} redraw/></div>
          </div>
          
        </div>
        <div className='container-group'>
          <div className='border-top'>
            <p>Reserva funcional</p>
            <div className='container-balance-graph'>
              <ViewBar {...{data:this.props.theads.arrReserva, domain: [0,100],checklist: arrCheck}}/>
            </div>
          </div>
        </div>
        </div>
        :
        ''}
     </div>
   );
 }
}



// WEBPACK FOOTER //
// ./src/components/HealthTable/GraphComponent.js